import { REDUCER_NAME } from './const'
import { REDUCER_NAME as PARENT_REDUCER_NAME } from '../const'

const NS = PARENT_REDUCER_NAME + '/' + REDUCER_NAME + '/'

export const FIND_INVOICE_BY_ID_REQUEST = NS + 'FIND_INVOICE_BY_ID_REQUEST'
export const FIND_INVOICE_BY_ID_SUCCESS = NS + 'FIND_INVOICE_BY_ID_SUCCESS'
export const FIND_INVOICE_BY_ID_ERROR = NS + 'FIND_INVOICE_BY_ID_ERROR'

export const SHOW_CONFIRMATION_MODAL = NS + 'SHOW_CONFIRMATION_MODAL'
export const CLOSE_CONFIRMATION_MODAL = NS + 'CLOSE_CONFIRMATION_MODAL'

export const CHANGE_INVOICE_CORRECTION_ITEM = NS + 'CHANGE_INVOICE_CORRECTION_ITEM'

export const CHANGE_INVOICE_CORRECTION_DATA = NS + 'CHANGE_INVOICE_CORRECTION_DATA'

export const CREATE_INVOICE_CORRECTION_REQUEST = NS + 'CREATE_INVOICE_CORRECTION_REQUEST'
export const CREATE_INVOICE_CORRECTION_SUCCESS = NS + 'CREATE_INVOICE_CORRECTION_SUCCESS'
export const CREATE_INVOICE_CORRECTION_ERROR = NS + 'CREATE_INVOICE_CORRECTION_ERROR'



// WEBPACK FOOTER //
// ./src/modules/invoice/state/correction/type.js